import {
  SpeedTest,
  SpeedTestConsolidatedResult,
  SpeedTestPostResult,
} from "../Speedtest";

export class MockSpeedTest implements SpeedTest {
  public version = "1";
  public bandwidth = 0;
  public icmpLatency = 1;
  public icmpPackageSent = 2;
  public pingCommands = true;
  public pingVideo = true;
  public provider = "blacknut";
  public jitterSent = 3;
  public jitterReceived = 4;
  public jitter = [1, 2, 3];
  public jitterDelay = 5;
}

export class MockSpeedTestPostResult implements SpeedTestPostResult {
  speedtests: SpeedTest[] = [new MockSpeedTest()];
  results: SpeedTestConsolidatedResult = {
    bandwidthQuality: 0,
    bandwidthResult: 0,
    jitterQuality: 0,
    jitterResult: 0,
    latencyQuality: 0,
    latencyResult: 0,
    packetLossQuality: 0,
    packetLossResult: 0,
    quality: 0,
  };
}
